var _path, _circle, _path2, _circle2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_15",
    "data-name": "Group 15",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.34,
    height: 16.923,
    viewBox: "0 0 24.34 16.923",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M34.669,307.112H28.734c-2.315,0-4.192,1.354-4.192,3.024l-1,3.564h16.32l-1-3.564C38.862,308.466,36.985,307.112,34.669,307.112Z",
    transform: "translate(-23.542 -296.777)",
    fill: "#8b96ab"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 3.78,
    cy: 3.78,
    r: 3.78,
    transform: "translate(4.379 0.716)",
    fill: "#8b96ab"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M43.412,305.344H38.3a.735.735,0,0,0-.7.535l1.237.4a1.561,1.561,0,0,1,.977.926l1.455,3.811h6.611l-.861-3.068C47.021,306.51,45.4,305.344,43.412,305.344Z",
    transform: "translate(-23.542 -296.777)",
    fill: "#8b96ab"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 3.299,
    cy: 3.299,
    r: 3.299,
    transform: "translate(14.611)",
    fill: "#8b96ab"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/Users.4b8c8f75e7042655119d2dab85e64405.svg";
export { ForwardRef as ReactComponent };